import { apiRequest } from '../Api/ApiRequest';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_triggerPortalErrorEmail(errorId) {

  return apiRequest({
    url: '/errors',
    method: 'post',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
    data: { errorId },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}
